S.indexedForm =
    {
        elements: {
            $searchInput: null,
            $resetIcon: null,
        },

        init()
        {
            this.initListners();
        },
        initListners()
        {
            this.elements.$resetIcon.on('click', (event) =>
            {
                this.elements.$searchInput.val('');
            });
        },
    };
